// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Video_wrapper__1J_aL","frame":"Video_frame__3POlC","error":"Video_error__1uhFN"};